module.exports = __webpack_public_path__ + "img/chedulingmiddlewaresystem.6e23538b.jpg";